import React, { useEffect, useState } from "react";
import { Box, DarkMode, Flex, Text, useToast } from "@chakra-ui/react";
import { packagesCardData } from "variables/general";
import CustomPriceCard from "components/PackageCard/CustomPriceCard";
import useApiReq from "variables/apireq";
import { Loader } from "components/Loader/loader";
import { TbDeviceAnalytics } from "react-icons/tb";
import { IoNewspaperOutline } from "react-icons/io5";
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { useLoader } from 'components/Loader/loader';

function PackageList() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const {setIsLoading,isLoading} = useLoader();
  const [PRData, setPRData] = useState([]);
  const [AnalyticsData, setAnalyticsData] = useState([]);
  const [ContentData, setContentData] = useState([]);
  const history = useHistory();
  const toast = useToast();
  const fetchPackages = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await useApiReq({
        method: "GET",
        url: "package/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        setData(res.response);
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPackages();
  }, []);
  useEffect(() => {
    if (error) {
      toast({
        title: "An error occurred.",
        description: error,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [error]);

  useEffect(() => {
    if (data) {
      const pr = data.filter((item) => item.type === "PR");
      const analytics = data.filter((item) => item.type === "ANALYTIC PR");
      const content = data.filter((item) => item.type === "CONTENT PR");
      setPRData(pr);
      setAnalyticsData(analytics);
      setContentData(content);
    }
  }, [data]);



    if (isLoading) {
      return <div></div>;
    }

  return (
    <Flex direction='column' pt={{ base: "120px", md: "75px" }}>
      <Box mb='3.5rem'>
        {/* PR Card */}
        <Text
          mx='auto'
          mb={{ base: "64px", md: "90px" }}
          textAlign='center'
          fontSize='4xl'
          color='#fff'
          fontWeight='bold'
        >
          <Text
            fontWeight='bold'
            fontSize='4xl'
            bg='#0099a2'
            px='8px'
            borderRadius='8px'
            mr='8px'
            as='span'
          >
            PR
          </Text>
          packages
        </Text>
        <Flex
          w='100%'
          style={{
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
            flexDirection: "row",
          }}
          // style={{
          //   justifyContent: "center",
          //   alignItems: "center",
          //   flexWrap: "wrap",
          // }}
          // templateColumns={{
          //   sm: "1fr",
          //   md: "1fr 1fr",
          //   xl: "repeat(3, 1fr)",
          // }}
          // templateRows={{
          //   sm: "1fr 1fr 1fr auto",
          //   md: "1fr 1fr",
          //   xl: "1fr",
          // }}
          gap='3rem'
        >
          {PRData?.map((card, index) => (
            // <PRCard key={index} card={card} />
            <CustomPriceCard
              key={index}
              index={index}
              card={card}
              setselectedPackages={(uuid) =>
                history.push(
                  `/${localStorage
                    .getItem("group")
                    .toLowerCase()}/order/create/?uuid=${uuid}`
                )
              }
            />
          ))}
        </Flex>

        <hr
          style={{
            border: "1px solid #fff",
            marginTop: "6rem",
            opacity: "0.3",
          }}
        />

        {/* Premium PR with Analytics Card */}
        <DarkMode>
          <Text
            mx='auto'
            my={{ base: "64px", md: "90px" }}
            textAlign='center'
            fontSize='4xl'
            color='#fff'
            fontWeight='bold'
          >
            <Text
              fontWeight='bold'
              fontSize='4xl'
              bg='#0099a2'
              px='8px'
              borderRadius='8px'
              mr='8px'
              as='span'
            >
              Premium PR
            </Text>
            packages with analytics
          </Text>
          <Flex
            w='100%'
            style={{
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
              flexDirection: "row",
            }}
            gap='3rem'
          >
            {AnalyticsData?.map((card, index) => (
              // <PRCard key={index} card={card} />
              <CustomPriceCard
                key={index}
                index={index}
                card={card}
                icon={TbDeviceAnalytics}
                setselectedPackages={(uuid) =>
                  history.push(
                    `/${localStorage
                      .getItem("group")
                      .toLowerCase()}/order/create/?uuid=${uuid}`
                  )
                }
              />
            ))}
          </Flex>
        </DarkMode>

        <hr
          style={{
            border: "1px solid #fff",
            marginTop: "6rem",
            opacity: "0.3",
          }}
        />
        {/* Content PR with Analytics Card */}
        <DarkMode>
          <Text
            mx='auto'
            my={{ base: "64px", md: "90px" }}
            textAlign='center'
            fontSize='4xl'
            color='#fff'
            fontWeight='bold'
          >
            <Text
              fontWeight='bold'
              fontSize='4xl'
              bg='#0099a2'
              px='8px'
              borderRadius='8px'
              mr='8px'
              as='span'
            >
              Content PR
            </Text>
            packages with analytics
          </Text>
          <Flex
            w='100%'
            style={{
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
              flexDirection: "row",
            }}
            gap='3rem'
          >
            {ContentData?.map((card, index) => (
              // <PRCard key={index} card={card} />
              <CustomPriceCard
                key={index}
                index={index}
                card={card}
                icon={IoNewspaperOutline}
                setselectedPackages={(uuid) =>
                  history.push(
                    `/${localStorage
                      .getItem("group")
                      .toLowerCase()}/order/create/?uuid=${uuid}`
                  )
                }
              />
            ))}
          </Flex>
        </DarkMode>
      </Box>
    </Flex>
  );
}

export default PackageList;
